import React, { createContext, ReactNode, useContext } from "react";
import { useScreenSize } from "../hooks/useScreenSize";

interface ScreenSizeContextType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  width: number;
  height: number;
}

const ScreenSizeContext = createContext<ScreenSizeContextType | undefined>(
  undefined
);

interface ScreenSizeProviderProps {
  children: ReactNode;
}

export const ScreenSizeProvider: React.FC<ScreenSizeProviderProps> = ({
  children,
}) => {
  const screenSize = useScreenSize();

  return (
    <ScreenSizeContext.Provider value={screenSize}>
      {children}
    </ScreenSizeContext.Provider>
  );
};

/**
 * Custom hook to access screen size context
 * @throws Error if used outside of ScreenSizeProvider
 */
export const useScreenSizeContext = (): ScreenSizeContextType => {
  const context = useContext(ScreenSizeContext);
  if (context === undefined) {
    throw new Error(
      "useScreenSizeContext must be used within a ScreenSizeProvider"
    );
  }
  return context;
};

export default ScreenSizeProvider;
